import React from 'react';
import { View } from 'react-native';
import TransactionLogo from 'features/transactions/components/TransactionLogo';
import { rem } from 'design-system';
import IconTransfer from 'design-system/icons/IconTransfer';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import GroupAvatar from './GroupAvatar';
export const GroupTransactionLogo = ({ transaction, ...rest }) => {
    const styles = useStyles(styleSet);
    const { originalTransactionId, paymentId, isSettlement, counterpartName } = transaction;
    const isLarge = 'R70' in rest;
    const borderWidth = isLarge ? rem(7.24) : 1;
    const size = isLarge ? rem(70) - borderWidth * 2 : rem(44);
    if ((isSettlement && !originalTransactionId) || paymentId) {
        return (<View style={[
                styles.transferBorder,
                { borderWidth },
                styles.border,
                isLarge && styles.largeBorderColor,
            ]}>
        <View style={[styles.transfer, { width: size, height: size }]}>
          <IconTransfer width={isLarge ? rem(32.5) : rem(24)} height={isLarge ? rem(32.5) : rem(24)} colorKey="positive" viewBox="0 0 24 24"/>
        </View>
      </View>);
    }
    const isOffline = !originalTransactionId && !paymentId;
    if (isOffline) {
        return (<GroupAvatar name={counterpartName} size={size} borderWidth={borderWidth} style={[styles.border, isLarge && styles.largeBorderColor]}/>);
    }
    return (<TransactionLogo {...rest} transaction={transaction} border={isLarge} light={isLarge} style={styles.transactionLogoBorder} backgroundDark/>);
};
const styleSet = createStyleSheets((colors) => ({
    border: {
        borderColor: colors.background.light,
    },
    largeBorderColor: {
        borderColor: colors.borders.iconStroke,
    },
    transactionLogoBorder: {
        borderColor: colors.background.light,
        borderWidth: 1,
        borderRadius: 999,
    },
    transferBorder: {
        borderRadius: 999,
        overflow: 'hidden',
    },
    transfer: {
        backgroundColor: colors.background.dark,
        alignItems: 'center',
        justifyContent: 'center',
    },
}));
